import { TextField } from "@mui/material";
import styled from "styled-components";
import {
  ChangeEvent,
  ChangeEventHandler,
  KeyboardEventHandler,
  KeyboardEvent,
  useEffect,
} from "react";
import { ReactRefI } from "type/common/ref.type";

type Props = {
  label: string;
  defaultValue?: string;
  value?: string | number;
  type?: string;
  multiline?: boolean;
  rows?: number;
  onEnterHandle?: Function;
  onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  onKeyDown?: KeyboardEventHandler<Element>;
  error?: boolean;
  fieldRef?: ReactRefI<string>;
  focused?: boolean;
  id?: string;
  autoFocus?: boolean;
  inputLabelShrink?: boolean;
};

const TextInputField = ({
  label,
  defaultValue,
  value,
  type,
  multiline,
  rows,
  onChange,
  onKeyDown,
  error,
  fieldRef,
  focused,
  id,
  autoFocus,
  inputLabelShrink,
}: Props) => {
  useEffect(() => {
    if (fieldRef) {
      fieldRef.current = defaultValue ?? "";
    }
  }, [defaultValue]);

  const onChangeHandle = (
    ev: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
  ) => {
    if (onChange) {
      onChange(ev);
    }
    if (fieldRef) {
      fieldRef.current = ev.target.value;
    }
  };

  const onKeyDownHandle = (ev: KeyboardEvent<Element>) => {
    if (onKeyDown) {
      onKeyDown(ev);
    }
  };

  const inputLabelProps: { shrink?: boolean } = {};
  if (typeof inputLabelShrink !== "undefined") {
    inputLabelProps.shrink = inputLabelShrink;
  }

  return (
    <>
      <TextStyleField
        onChange={onChangeHandle}
        onKeyDown={onKeyDownHandle}
        // onKeyDown={(event: any) => {
        //   if (event.keyCode === 13) {
        //     console.log("aa 2", event.keyCode);
        //   }
        // }}
        label={label}
        defaultValue={defaultValue}
        value={value}
        error={error}
        type={type}
        multiline={multiline}
        rows={rows}
        name="textField"
        id={id ?? undefined}
        focused={focused}
        autoFocus={typeof autoFocus !== "undefined" ? autoFocus : true}
        InputLabelProps={inputLabelProps}
      />
    </>
  );
};

const TextStyleField = styled(TextField)`
  &&& .MuiFormLabel-root {
    color: currentColor;
  }

  &&& .MuiInputBase-root {
    border: ${(props) => (props?.error ? "red" : "auto")};
  }
`;

export default TextInputField;
